module.exports = {
      id: "down-arrow-usage",
      viewBox: "0 0 9.887 6",
      url: "/" + "sprite-bc5ff1507898764e0c54e53c34039c01.svg#down-arrow",
      toString: function () {
        return this.url;
      }
    }